import {defineStore} from "pinia";
import apiClient, { buildQuery } from "@/services/apiClient";
//import router from './router'


export const useStore = defineStore('stores', {
    state: () => ({
        globalIsTakvimi: [],
        kurumIsTakvimi: [],
        genelMudurlukList: [],
        birimlerListesi: [],
        genelMudurlukKisaltma: "",
        kurumKodu: "",
        adiSoyadi: "",
        isLogin: false,
        genelMudurlukAdi: "",
        oncekiEtkinlikler: true,
        genelMudurlukId: 0,
        birimId: 0,
        yilId: 2026,
        ayId: new Date().getMonth() + 1,
        oncelik: 4,
        gorunum: 2,
        boxView: false,
        rtName: '',
        searchText: '' // Arama metni

    }),
    getters: {
        // birimId'ye göre filtrelenmiş kurumIsTakvimi
        filteredKurumIsTakvimi: (state) => {
            // birimId 0 ise tüm kayıtları döndür
            if (state.birimId === 0 || !state.birimId) {
                return state.kurumIsTakvimi;
            }
            
            // birimId'ye göre filtrele
            return state.kurumIsTakvimi.filter(item => {
                if (!item.ILGILIBIRIM) {
                    return false;
                }
                
                // ILGILIBIRIM virgülle ayrılmış string olabilir: "15966, 15965, 15962"
                const birimler = String(item.ILGILIBIRIM).split(',').map(b => b.trim());
                
                // birimId bu listede geçiyorsa true döndür
                return birimler.includes(String(state.birimId));
            });
        },
        // Arama metnine göre filtrelenmiş globalIsTakvimi
        filteredGlobalIsTakvimi: (state) => {
            if (!state.searchText || state.searchText.trim() === '') {
                return state.globalIsTakvimi;
            }
            
            const searchLower = state.searchText.toLowerCase().trim();
            
            return state.globalIsTakvimi.filter(item => {
                if (!item) return false;
                
                // BASLIK alanında ara
                const baslik = (item.BASLIK || '').toLowerCase();
                if (baslik.includes(searchLower)) return true;
                
                // ACIKLAMA alanında ara
                const aciklama = (item.ACIKLAMA || '').toLowerCase();
                if (aciklama.includes(searchLower)) return true;
                
                // HOST alanında ara
                const host = (item.HOST || '').toLowerCase();
                if (host.includes(searchLower)) return true;
                
                return false;
            });
        },
        // Arama metnine göre filtrelenmiş kurumIsTakvimi
        filteredKurumIsTakvimiWithSearch: (state, getters) => {
            const birimFiltered = getters.filteredKurumIsTakvimi;
            
            if (!state.searchText || state.searchText.trim() === '') {
                return birimFiltered;
            }
            
            const searchLower = state.searchText.toLowerCase().trim();
            
            return birimFiltered.filter(item => {
                if (!item) return false;
                
                // BASLIK alanında ara
                const baslik = (item.BASLIK || '').toLowerCase();
                if (baslik.includes(searchLower)) return true;
                
                // ACIKLAMA alanında ara
                const aciklama = (item.ACIKLAMA || '').toLowerCase();
                if (aciklama.includes(searchLower)) return true;
                
                // HOST alanında ara
                const host = (item.HOST || '').toLowerCase();
                if (host.includes(searchLower)) return true;
                
                return false;
            });
        }
    },
    actions: {
        async getIsTakvimi(ay, yil, gm) {
            this.globalIsTakvimi = [];
            if (!ay || !yil) {
                return;
            }
            try {
                const query = buildQuery({ AY: ay, YIL: yil, GM: gm });
                const { data } = await apiClient.get(`genel_takvim_ay_yil.php${query}`);
                this.globalIsTakvimi = data;
            } catch (error) {
                console.error(error);
            }
        },
        async getKurumTakvimi(ay, yil) {
            this.kurumIsTakvimi = [];
            try {
                console.log(ay+" "+yil)
                const query = buildQuery({ AY: ay, YIL: yil });
                const { data } = await apiClient.get(`kurum_takvim_ay_yil.php${query}`);
                this.kurumIsTakvimi = data;
            } catch (error) {
                console.error(error);
            }
        },
        getKurumTakvimiFiltreli(KNO) {
            return this.kurumIsTakvimi.filter(x => x.ILGILIBIRIM == KNO);
        },
        async getKullaniciBilgileri() {
            try {

                const { data } = await apiClient.get('kurumgiris.php');
                if (data !== false) {
                    this.isLogin = true;
                    this.adiSoyadi = data.ADISOYADI;
                    this.genelMudurlukAdi = data.GOREVKURUMADI;
                } else {
                    this.adiSoyadi = "";
                    this.genelMudurlukAdi = "";
                    this.isLogin = false;
                    this.kurumIsTakvimi = [];
                }
            } catch (error) {
                console.error(error);
            }

            try {
                await this.getKurumTakvimi(this.ayId, this.yilId);
            } catch (e) {
                // logged in child
            }

            try {
                const { data } = await apiClient.get('kurum_birim.php');
                this.birimlerListesi = Array.isArray(data) ? data : [];
            } catch (error) {
                console.error(error);
            }

            try {
                const { data } = await apiClient.get('kurum_gm.php');
                if (Array.isArray(data) && data.length > 0) {
                    this.genelMudurlukKisaltma = data[0].HOST || "";
                    this.kurumKodu = data[0].KURUMKODU || "";
                } else {
                    this.genelMudurlukKisaltma = "";
                    this.kurumKodu = "";
                }
            } catch (error) {
                console.error(error);
            }
        },
        async getGenelMudurlukler() {
            try {
                const { data } = await apiClient.get('genelmudurlukler.php');
                if (Array.isArray(data) && data.length !== this.genelMudurlukList.length) {
                    this.genelMudurlukList = data;
                }
            } catch (error) {
                console.error(error);
            }
        },
        getOncekiEtkinlikler(state) {
            this.oncekiEtkinlikler = state;
        },
        getGenelMudurlukIdUpdate(state) {
            this.genelMudurlukId = state;
            this.getIsTakvimi(this.ayId, this.yilId, state);
        },
        getBirimIdUpdate(state) {
            this.birimId = state;
        },
        getTakvimYilUpdate(state, isLogin) {
            this.yilId = state;
            if (isLogin) {
                this.getKurumTakvimi(this.ayId, this.yilId);
            }else {
                this.getIsTakvimi(this.ayId, state);
            }

        },
        getTakvimAyUpdate(state) {
            this.ayId = state
        },
        getOnemSirasi(state) {
            this.oncelik = state;
        },
        getGorunumUpdate(state) {
            this.gorunum = state;
        },
        getrouteName(state) {
            this.rtName = state;
        },
        getSearchTextUpdate(state) {
            this.searchText = state;
        }
    },
})